<nav class="toolbar navbar navbar-light" autocomplete="off">
    <form class="form-inline">
        <button class="btn btn-outline-success" type="button" title="Nuevo" (click)="onAdd()"><i class="fa fa-file-o"></i> Nuevo </button>
        <button *ngIf="!visibilitySpinner" type="button" class="btn btn-outline-success" title="Exportar" (click)="onExportExcel()"><i class="fa fa-file-excel-o"></i> Exportar </button>
        <button *ngIf="visibilitySpinner" type="button" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Exportando
        </button>
    </form>
</nav>

<form [formGroup]="form" class="container-fluid" autocomplete="off">
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <h4>Buscador de Instalaciones</h4>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsed = !isCollapsed"
                       [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Filtros
                            <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    
                    <div class="card-body">
                        
                        <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">

                            <div class="row">

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpIdentificador">Identificador Instalación</label>
                                    <input formControlName="Identificador" name="Identificador" title=""
                                           class="form-control" id="inpIdentificador" type="text" value="" maxlength="50">
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpOperador">Operador</label>
                                    <input formControlName="Operador" name="Operador" title=""
                                           class="form-control" id="inpOperador" type="text" value="" maxlength="150">
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="intTipoInstalacion">Tipo Instalación</label>
                                    <ng-select loadingText="Cargando..."
                                               [items]="listTipoInstalacion"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdTipoInstalacion"
                                               [readonly]="!listTipoInstalacion || listTipoInstalacion.length === 0"
                                               [loading]="!listTipoInstalacion || listTipoInstalacion.length === 0"
                                               notFoundText="Tipo Instalación no encontrada"
                                               placeholder="-- Seleccione un Tipo Instalación --"
                                               clearAllText="Eliminar selección">
                                    </ng-select>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="intProvincia">Provincia</label>
                                    <ng-select loadingText="Cargando..."
                                               [items]="listProvincia"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdProvincia"
                                               [readonly]="!listProvincia || listProvincia.length === 0"
                                               [loading]="!listProvincia || listProvincia.length === 0"
                                               notFoundText="Provincia no encontrada"
                                               placeholder="-- Seleccione una Provincia --"
                                               clearAllText="Eliminar selección">
                                    </ng-select>
                                </div>

                            </div>

                            <div class="row">

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpNumRegistro">Num. Registro</label>
                                    <input formControlName="NumRegistro" name="NumRegistro" title=""
                                           class="form-control" id="inpNumRegistro" type="text" value="" maxlength="50">
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpTelefono">Teléfono</label>
                                    <input formControlName="Telefono" name="Telefono" title=""
                                           class="form-control" id="inpTelefono" type="text" value="" maxlength="50">
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpEmail">Email</label>
                                    <input formControlName="Email" name="Email" title=""
                                           class="form-control" id="inpEmail" type="text" value="" maxlength="100">
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpTecnicoResponsable">Técnico Responsable</label>
                                    <input formControlName="TecnicoResponsable" name="TecnicoResponsable" title=""
                                           class="form-control" id="inpTecnicoResponsable" type="text" value="" maxlength="200">
                                </div>

                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group-0 float-right">

                                    <div class="btn-group">
                                        <button name="btnSearch" class="btn btn-secondary btn-sm" type="submit" title="Realiza una búsqueda"
                                                (click)="onSearchButton()">
                                            <i class="fa fa-search"></i> Buscar
                                        </button>
                                    </div>

                                    <div class="btn-group">
                                        <button class="btn btn-secondary btn-sm" type="button" title="Limpia los filtros" (click)="onCleanButton()">
                                            <i class="fa fa-eraser"></i> Limpiar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>


        <!--DATAGRID-->

        <div *ngIf="searchingButton" class="row">
            <div class="col-md-12">
                <div class="card card-accent-success">
                    <div class="card-header-buscador">
                        <i class="fa fa-align-justify"></i> Listado de Instalaciones
                    </div>

                    <div class="card-body-grid">

                        <p-table #tableSearch autoLayout="true" [value]="resultInstalacion?.ResultList" [lazy]="true" (onLazyLoad)="onSearchLazy($event)" [paginator]="true"
                                 [columns]="cols" sortField="Nombre" sortOrder="-1" [rows]="resultInstalacion?.PageSize" [totalRecords]="resultInstalacion?.TotalCount" [loading]="loading"
                                 styleClass="table table-responsive-sm  table-striped table-sm" [ngClass]="displayGridHidden(resultInstalacion?.ResultList)">
                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                        {{col.header}}
                                        <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                                <tr>
                                    <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                        <span *ngIf="(col.field!=='Link' && col.field!=='Baja')">{{rowData[col.field]}}</span>

                                        <span *ngIf="col.field==='Baja'">{{rowData[col.field] | siNo}}</span>

                                        <div *ngIf="col.field==='Link'" class="btn-group">
                                            <button (click)="onEdit(rowData)" title="Editar" type="button"
                                                    class="btn btn-sm btn-info">
                                                <span class="fa fa-edit"></span>
                                            </button>

                                            <button (click)="onDelete(rowData)" type="button" title="ELiminar"
                                                    class="btn btn-sm btn-danger">
                                                <span class="fa fa-remove"></span>

                                            </button>

                                        </div>
                                    </td>
                                </tr>

                            </ng-template>
                        </p-table>

                        <div *ngIf="tableSearch?.totalRecords > 1" class="p-2">Se han encontrado {{ tableSearch.totalRecords | number:'1.0-0':'es-ES' }} registros</div>
                        <div *ngIf="tableSearch?.totalRecords === 1" class="p-2">Se ha encontrado {{ tableSearch.totalRecords | number:'1.0-0':'es-ES' }} registro</div>
                        <div class="empty-grid" *ngIf="tableSearch.totalRecords === 0">No se ha encontrado ningún registro</div>
                    </div>

                </div>
            </div>
        </div>

    </div>

</form>
